<div class="container-fluid d-flex flex-column justify-content-center bg-primary" style="height:100vh">
  <!--<div class="loading loader" *ngIf="loader"></div>
  <div class="pa-overlay" *ngIf="loader"></div>-->
  <div class="row d-flex flex-row justify-content-center">
    <div class="col-xs-10 col-sm-8 col-md-6 col-lg-6">
      <div class="card border-0">
        <div class="card-header d-flex flex-wrap align-items-center bg-dark text-white">
          <span class="pt-1" style="font-size:25px">Select Customer</span>
        </div>
        <div class="card-body row ps-5" style="height: 459px; overflow: auto;">
          <div *ngFor="let customer of customerList" class="custom-control custom-radio"
            [ngClass]="{'col-4' : isMoreCustomers,'col-6' : !isMoreCustomers }">
            <input type="radio" style="cursor: pointer;" [checked]="customer == selectedCustomer" [value]="customer"
              [name]="customer" (click)="setSelectedCustomer(customer)" id="si_{{customer}}"
              class="custom-control-input">
            <label class="custom-control-label" style="cursor: pointer;"
              for="si_{{customer}}">{{formatName(customer)}}</label>
          </div>
        </div>
        <div class="card-footer text-muted small">
          <button class="btn btn-primary" (click)="submit()">Submit</button>
        </div>
      </div>
    </div>
  </div>
</div>